import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import Quill from 'quill';

@Component({
  selector: 'app-ckeditor',
  templateUrl: './ckeditor.component.html',
  styleUrls: ['./ckeditor.component.scss'],
  standalone: false
})
export class CkeditorComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() data: string = '';
  @Input() height: string = '250px';

  @Output() contentChanged = new EventEmitter<{ html: string; editor: any }>();
  @Output() editorReady = new EventEmitter<any>();

  @ViewChild('editorContainer', { static: true }) editorContainer!: ElementRef;

  private editorInstance: Quill | null = null;
  private lastEmittedHtml: string = '';
  private initialized = false;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.editorInstance = new Quill(this.editorContainer.nativeElement, {
      theme: 'snow',
      modules: {
        toolbar: [
          [{ 'font': [] }, { 'size': ['small', false, 'large', 'huge'] }],
          [{ 'color': [] }, { 'background': [] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
          ['clean']
        ]
      }
    });

    if (this.data) {
      this.editorInstance.clipboard.dangerouslyPasteHTML(this.data);
    }

    this.editorInstance.on('text-change', () => {
      const html = this.editorInstance!.root.innerHTML;
      this.lastEmittedHtml = html;
      this.contentChanged.emit({ html, editor: this.editorInstance });
    });

    this.initialized = true;
    this.editorReady.emit(this.editorInstance);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange && this.initialized) {
      const incomingHtml = this.data || '';

      if (incomingHtml === this.lastEmittedHtml) {
        return;
      }

      if (this.editorInstance) {
        const currentHtml = this.editorInstance.root.innerHTML;
        if (currentHtml !== incomingHtml) {
          this.editorInstance.clipboard.dangerouslyPasteHTML(incomingHtml);
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.editorInstance = null;
  }

  // ─── Focus Utility ────────────────────────────────────────────────────

  focusEditorAtEnd(): void {
    if (!this.editorInstance) return;
    const length = this.editorInstance.getLength();
    this.editorInstance.setSelection(length, 0);
    this.editorInstance.focus();
  }
}
